var _path;
import * as React from "react";
var SvgLogoLsuinline = function SvgLogoLsuinline(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.022 0H0v32h28.757v-6.463H11.022zM31.297 7.121v12.133h23.337v3.493c0 1.52-1.678 2.767-3.765 2.767H31.297v6.532h24.72c5.307 0 9.616-3.198 9.616-7.121V12.724H42.478V9.299c0-1.519 1.678-2.767 3.719-2.767h19.527V0H40.959c-5.262 0-9.593 3.198-9.593 7.121zM91.85 0v22.679c0 1.565-1.678 2.79-3.765 2.79h-8.459V.091H68.649v31.932h24.675c5.262 0 9.593-3.198 9.593-7.121V-.045z"
  })));
};
export default SvgLogoLsuinline;